/*
 * @Author: Cozy
 * @Date: 2024-05-25 14:22:52
 * @LastEditors: Cozy
 * @LastEditTime: 2024-06-27 16:45:31
 * @FilePath: /SChatUI/src/LoginPage.js
 * @Description: 
 * 
 * Copyright (c) 2024 by Cozy, All Rights Reserved. 
 */
// LoginPage.js
import React, { useState } from 'react';
import axios from 'axios';
import { useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { AuthContext } from './AuthContext';

export default function LoginPage() {
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const navigate = useNavigate();
    const { setAuth, updateAuth } = useContext(AuthContext); 

    const handleLogin = async (e) => {
        e.preventDefault();
        if (!username || !password) {
            alert("Please enter both username and password.");
            return;
        }
        try {
            const response = await axios.post(`${process.env.REACT_APP_BASE_URL}/login`, {
                username,
                password
            });
            const { access_token, refresh_token, user_name, expires_in, accessible_services } = response.data;
            // console.debug("Login response:", response.data);
            updateAuth(access_token, refresh_token, user_name, expires_in, accessible_services);

            // 导航到用户的第一个可访问服务
            if (accessible_services.length > 0) {
                navigate(`/${accessible_services[0]}/`);
                console.debug(`navigate to /${accessible_services[0]}/`);
            } else {
                navigate('/unauthorized');
            }
        } catch (error) {
            console.error("Login failed:", error);
            alert("Login failed, please check your credentials.");
        }
    };

    return (
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh', backgroundColor: '#f0f0f0' }}>
            <form onSubmit={handleLogin} style={{ display: 'flex', flexDirection: 'column', gap: '20px', padding: '20px', borderRadius: '5px', boxShadow: '0px 0px 10px rgba(0,0,0,0.1)' }}>
                <h2 style={{ textAlign: 'center' }}>Login</h2>
                <input type="text" placeholder="Username" value={username} onChange={(e) => setUsername(e.target.value)} style={{ padding: '10px', fontSize: '16px' }} />
                <input type="password" placeholder="Password" value={password} onChange={(e) => setPassword(e.target.value)} style={{ padding: '10px', fontSize: '16px' }} />
                <button type="submit" style={{ padding: '10px', fontSize: '16px', backgroundColor: '#007BFF', color: 'white', border: 'none', borderRadius: '5px', cursor: 'pointer' }}>Login</button>
            </form>
        </div>

    );
}
